<template>
  <van-nav-bar 
    title="套餐"
  />
  <div class="collection_title_menu">
    <div class="collection_content">
      <div class="collection_items">
        <div
          class="collection_item"
          v-for="item in CollectionList"
          :key="item.Id"
        >
          <van-card
            currency=""
            :price="item.PriceFormat"
            :desc="item.Desc"
            :title="item.Name"
            thumb="https://fastly.jsdelivr.net/npm/@vant/assets/ipad.jpeg"
          >
            <template #tags> </template>
            <template #footer>
              <van-button
                size="small"
                icon="plus"
                @click="AddCollection(item)"
              ></van-button>
            </template>
          </van-card>
        </div>
      </div>
    </div>

    <br />
    <br />
    <br />
    <br />
    <br />
  </div>
  <tabbar :active="1" />
</template> 
<script >
import axios from "../../commons/AxiosMethod.js";
import productBbroadwise from "../../components/productBroadwise.vue";
import tabbar from "../../components/tabbars/tabbar.vue";

import { Collapse, CollapseItem, Tab, Tabs } from "vant";
export default {
  data() {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,

      active: "",
      CollectionList: [], //合集列表
      CollectionOpt: {}, //当前分类
    };
  },
  name: "App",
  mounted() {
    this.GetCollections();
  },
  components: {
    productBbroadwise,
    tabbar,
  },
  methods: {
    //获取合集
    GetCollections() {
      axios.apiMethod(
        "/shoppings/Collection/GetCollectionList",
        "get",
        {},
        (result) => {
          this.CollectionList = result.Data;
        }
      );
    },
    //新增合集
    AddCollection(item) {
      axios.apiMethod(
        "/shoppings/Collection/AddCollection",
        "get",
        { Id: item.Id },
        (result) => {
          console.log(JSON.stringify(result.Data));

          if (result.Data.Success) {
            this.$router.push({
              path: "CollectionItems",
              query: {
                cartId: result.Data.Id,
                collectionId: item.Id,
              },
            });
          } else {
            Toast(result.Data.Msg);
          }
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.collection_title_menu {
  .collection_content {
    .collection_items {
      background-color: #fff;
      .collection_item {
        margin-top: 10px;
      }
    }
  }
}
</style>
